<template>
    <div class="cz2__panel cz2__panel--secondary cz2__panel--secondary-fullscreen cz2__product-help">
        <focus-lock :disabled="focusLockDisabled">
            <div class="cz2__panel__header cz2__panel__header--help">
                <div class="cz2__details-header">
                    <div class="cz2__type__header cz2__product-title">{{$t('MENU_HELP')}}</div>
                </div>
            </div>

            <div class="cz2__panel__body">
                <div class="cz2__menu__items">
                    <menu-item v-for="topic in topics" :key="topic.header"
                        class="cz2__menu-item--full-width"
                        :title="topic.header"
                        @selected="showTopic(topic)"
                    ></menu-item>
                </div>
            </div>

            <div class="cz2__panel__actions">
                <button class="cz2__panel-action cz2__panel-action--cancel" @click.prevent="cancel"><span>{{$t('MENU_BACK')}}</span></button>
            </div>
        </focus-lock>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__product-help {
            .cz2__menu__items {
                flex-direction: column;
            }

            .cz2__panel__header.cz2__panel__header--with-back-button {
                display: flex;
                align-items: center;

                height: 75px;

                @include respond-above(sm) {
                    height: 104px;
                    padding: 10px 20px 0;
                }

                .cz2__panel-header__back-button {
                    display: block;
                }

                .cz2__panel__back-button {
                    flex: 0 0 auto;

                    width: 44px;
                    height: 44px;

                    margin-right: 24px;

                    background: transparent url(../assets/back@2x.png) no-repeat center/contain;
                }

                .cz2__details-header {
                    flex: 1 0 auto;
                    width: 1px;
                }
            }
        }

        .cz2__panel__header--help {
            display: flex;
            align-items: center;
        }
    }
</style>

<script>
    import FocusLock from 'vue-focus-lock';

    import MenuItem from './MenuItem.vue';

    export default {
        components: {
            FocusLock,
            MenuItem,
        },
        data() {
            return {
                focusLockDisabled: true,
            };
        },
        computed: {
            /**
             * Current view controller.
             */
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            /**
             * Retrives panel content.
             */
            topics() {
                if (this.viewController == null) {
                    return [];
                }

                const list = [];

                for (let i = 1; ; i += 1) {
                    const header = this.viewController.blueprint.custom[`v-help-${i}-header`];
                    const content = this.viewController.blueprint.custom[`v-help-${i}-content-html`];

                    if (header && content) {
                        list.push({
                            header,
                            content,
                        });
                    } else {
                        break;
                    }
                }

                return list;
            },
        },
        mounted() {
            // Otherwise this messes with transition animation because browsers will try to scroll to the focused item, which would be off-screen.
            this.$store.state.eventBus.$once('secondaryEntered', () => {
                // this.focusLockDisabled = false;
            });
        },
        methods: {
            /**
             * Go back.
             */
            cancel() {
                // Go back to the main screen.
                this.$store.dispatch('selectStep', null);
            },

            /**
             * Shows a topic.
             */
            showTopic(topic) {
                // Go back to the main screen.
                this.$store.dispatch('selectStep', {
                    step: 'help-child',
                    parameters: {
                        topic,
                    },
                });
            },
        },
    };
</script>
